class ReviewRating {
  constructor({
    isShowOverallRating,
    overallRating,
    maxOverallRating,
    maxCompetencyRating,
    maxObjectiveRating,
    providerTypes,
    objectiveGraphData,
    competencyGraphData,
    ratingSplit,
    ratingType,
    isRatingCalibrated,
  }) {
    this.isShowOverallRating = isShowOverallRating;
    this.overallRating = overallRating;
    this.maxOverallRating = maxOverallRating;
    this.maxCompetencyRating = maxCompetencyRating;
    this.maxObjectiveRating = maxObjectiveRating;
    this.providerTypes = providerTypes;
    this.objectiveGraphData = objectiveGraphData;
    this.competencyGraphData = competencyGraphData;
    this.ratingSplit = ratingSplit;
    this.ratingType = ratingType;
    this.isRatingCalibrated = isRatingCalibrated;
  }

  static fromJSON({
    isShowOverallRating,
    overallRating,
    maxOverallRating,
    maxCompetencyRating,
    maxObjectiveRating,
    providerTypes,
    objectiveGraphData,
    competencyGraphData,
    ratingSplit,
    ratingType,
    isRatingCalibrated,
  }) {
    competencyGraphData = (competencyGraphData ?? []).map((item) => {
      const { ratings } = item;
      return {
        id: item.id,
        label: item.label,
        maxRating: item.maxRating,
        ...ratings,
      };
    });

    ratingSplit = Object.keys(ratingSplit).map((key) => ({
      type: key,
      value: ratingSplit[key],
    }));

    return new ReviewRating({
      isShowOverallRating,
      overallRating,
      maxOverallRating,
      maxCompetencyRating,
      maxObjectiveRating,
      providerTypes,
      objectiveGraphData,
      competencyGraphData,
      ratingSplit,
      ratingType,
      isRatingCalibrated,
    });
  }
}

export default ReviewRating;
